<template>
  <div class="page">
    <div class="header">
      <div class="header-left">
        <div class="logo">
          <img src="../assets/images/logo.png" alt="" />
        </div>
        <div class="nav-list">
          <img class="nav" src="../assets/images/nav_1.png" @click="next(0)" alt="" />
          <img class="line" src="../assets/images/line.png" alt="" />
          <img class="nav" src="../assets/images/nav_2.png" @click="next(1)" alt="" />
          <img class="line" src="../assets/images/line.png" alt="" />
          <img class="nav" src="../assets/images/nav_3.png" @click="next(2)" alt="" />
          <img class="line" src="../assets/images/line.png" alt="" />
          <a href="mailto:cs_na@flame-games.com"><img class="nav" src="../assets/images/nav_4.png" alt="" /></a>
        </div>
      </div>
      <div class="more">
        <img class="icon-1" @click="goLink('fb')" src="../assets/images/fb_icon.png" alt="" />
        <img class="line" src="../assets/images/line.png" alt="" />
        <img class="icon-2" @click="goLink('dsc')" src="../assets/images/discord_icons.png" alt="" />
      </div>
    </div>
    <full-page :options="options" ref="fullpage" id="fullpage">
      <div class="section" data-anchor="home">
        <div class="bg bg-1">
          <div class="content">
            <div class="download">
              <img @click="goLink('gp')" src="../assets/images/download_1.png" alt="" />
              <img @click="goLink('ios')" src="../assets/images/download_2.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="section" data-anchor="home">
        <div class="bg bg-2">
          <div class="title">
            <img src="../assets/images/title_2.png" alt="" />
          </div>
          <div class="swiper-box">
            <div class="prev">
              <img src="../assets/images/prev.png" alt="" class="swiper-button" @click="clickPrev" />
            </div>
            <swiper ref="mySwiper" :options="swiperOptions">
              <swiper-slide class="swiper-slide" v-for="(item, index) in 4" :key="index">
                <img :src="require(`../assets/images/swiper_${index + 1}.png`)" alt="" />
              </swiper-slide>
            </swiper>
            <div class="next">
              <img src="../assets/images/next.png" alt="" class="swiper-button" @click="clickNext" />
            </div>
          </div>
        </div>
      </div>
      <div class="section" data-anchor="home/pay">
        <!-- <router-view></router-view> -->
        <Purchase></Purchase>
      </div>
      <div class="section footer" data-anchor="home">
        <div class="content">
          <div class="left">
            <div class="left-item1">
              <div class="privacy">
                <span @click="showPrivacy">Privacy Policy</span>
                <span @click="showService">Mobile Terms of Service</span>
              </div>
              <div class="contact">
                <span>CONTACT US</span>
                <span>cs_na@flame-games.com</span>
              </div>
            </div>
            <div class="left-item2">
              <img class="download" @click="downloadApk" src="../assets/images/apk_download.png" alt="" />
            </div>
          </div>
          <div class="right">
            <img src="../assets/images/footer_logo.png" alt="" />
            <span>© 2022 Flamegames.All Rights Reserved</span>
          </div>
        </div>
      </div>
    </full-page>
  </div>
</template>

<script>
import Purchase from '../views/modules/Purchase.vue'

export default {
  name: 'Index',
  components: { Purchase },
  data() {
    return {
      active_index: 0,
      link_list: {
        gp: 'https://play.google.com/store/apps/details?id=com.hookylin.us.ryjq.google',
        ios: 'https://apps.apple.com/us/app/id6443894738',
        fb: 'https://www.facebook.com/GloriousAdventure/',
        dsc: 'https://discord.gg/SJGfcTME5R'
      },
      options: {
        // autoScrolling: false,
        // section配置
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        //是否显示导航，默认为false
        // navigation: true,
        //为每个section设置背景色
        sectionsColor: ['#000', '#000', '#000', '#000'],
        // 控制动画出现
        onLeave: (index, nextIndex, direction) => {
          this.active_index = nextIndex.index
        }
      },
      // 轮播图配置
      swiperOptions: {
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 30,
          stretch: 60,
          depth: 60,
          modifier: 2,
          slideShadows: true
        },
        autoplay: {
          delay: 3000, //滚动时间间隔
          disableOnInteraction: false //不可用当用户触摸后，false代表失效
        },
        loop: true, //循环滚动
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 1.4,
        centeredSlides: true,
        // spaceBetween: '-20%',
        // spaceBetween: 10,
        // history: 'love',
        // 设置点击箭头
        navigation: {
          nextEl: '.next',
          prevEl: '.prev'
        }
      },
      deviceList: []
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
    pay() {
      return this.$store.state.pay
    }
  },
  created() {},
  methods: {
    showPrivacy() {
      let routeData = this.$router.resolve({ path: '/privacy' })
      window.open(routeData.href, '_blank')
    },
    showService() {
      let routeData = this.$router.resolve({ path: '/service' })
      window.open(routeData.href, '_blank')
    },
    /**跳转链接 */
    goLink(key) {
      window.open(this.link_list[key], '_blank')
    },
    /**页面切换 */
    next(index) {
      // 向下滚动一页
      this.active_index = index
      this.$refs.fullpage.api.moveTo(index + 1)
    },
    /* 前一步 */
    clickPrev() {
      const that = this
      const length = that.deviceList.length
      if (that.activeBtn <= 0 || length == 0) {
        return false
      }
    },
    /* 后一步 */
    clickNext() {
      const that = this
      const length = that.deviceList.length
      if (that.activeBtn >= length - 1 || length == 0) {
        return false
      }
    },
    downloadApk() {
      var a = document.createElement('a')
      a.href = './main-release-paypal-20230221.apk'
      a.download = 'Glorious Adventure.apk'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
    }
  },
  mounted() {
    if (this.pay) {
      this.$refs.fullpage.api.silentMoveTo(3)
      this.$store.commit('setPay', false)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/keyframes.less';
@import '../assets/css/pc.less';
.page {
  position: relative;
  width: 100wv;
  height: 100vh;
}
// /* PC端 */
// @media screen and (min-width: 769px) {

// }

// /* 移动端  */
// @media screen and (max-width: 769px) {
//   @import '../assets/css/m.less';
// }
</style>
